import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth } from 'firebase/auth';
import { getFirestore, enableNetwork } from 'firebase/firestore';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize App Check with reCAPTCHA Enterprise
// For local development, use debug token: set window.FIREBASE_APPCHECK_DEBUG_TOKEN = true in console
//console.log('[App Check] Initializing...', {
//    hasRecaptchaKey: !!process.env.REACT_APP_RECAPTCHA_SITE_KEY,
//    hostname: window.location.hostname,
//    recaptchaKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY ?
//        process.env.REACT_APP_RECAPTCHA_SITE_KEY.substring(0, 20) + '...' :
//        'NOT SET'
//});

if (process.env.REACT_APP_RECAPTCHA_SITE_KEY) {
    try {
        // Enable debug mode for localhost
        if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
            // Use debug token from .env.development if set, otherwise auto-generate
            const debugToken = process.env.REACT_APP_APPCHECK_DEBUG_TOKEN;
            if (debugToken) {
                // @ts-ignore - Use specific debug token (already registered in Firebase Console)
                window.FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;
                console.log('[App Check] Using registered debug token from env');
            } else {
                // @ts-ignore - Auto-generate debug token (need to register in Firebase Console)
                window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
                console.log('[App Check] Auto-generating debug token - register it in Firebase Console');
                console.log('[App Check] After registration, add it to .env.development as REACT_APP_APPCHECK_DEBUG_TOKEN');
            }
        }

        const appCheckInstance = initializeAppCheck(app, {
            provider: new ReCaptchaEnterpriseProvider(process.env.REACT_APP_RECAPTCHA_SITE_KEY),
            isTokenAutoRefreshEnabled: true
        });
        console.log('[App Check] ✓ Initialized with reCAPTCHA Enterprise');

        // Debug token logging removed to keep console clean
    } catch (error) {
        console.error('[App Check] ✗ Error initializing:', error);
    }
} else {
    console.warn('[App Check] ✗ Not initialized: REACT_APP_RECAPTCHA_SITE_KEY not set');
}

// Initialize Analytics only if supported
export const analytics = isSupported()
    .then(yes => yes ? getAnalytics(app) : null)
    .catch(error => {
        console.error('[Analytics] Failed to check if supported:', error);
        return null;
    });

const auth = getAuth(app);
const db = getFirestore(app);

// Log initialization
//console.log('Firebase initialized with config:', {
//    projectId: firebaseConfig.projectId,
//    authDomain: firebaseConfig.authDomain
//});

enableNetwork(db).catch(err => {
    console.error("Firestore network enable failed:", err);
});

export { auth, db };